interface Props {
  [key: string]: any
}

function CircleDashedIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 240 240" {...rest} xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="120"
        cy="120"
        fill="none"
        opacity="0.6"
        r="110"
        stroke="url(#gradient)"
        strokeDasharray="10 10"
        strokeWidth="2"
      />
      <defs>
        <linearGradient id="gradient" x1="0%" x2="100%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#a855f7" />
          <stop offset="50%" stopColor="#ec4899" />
          <stop offset="100%" stopColor="#3b82f6" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default CircleDashedIcon
